<div class="card">
    <div class="card-header">
        <h4>Merchant Withdrawl Report</h4>
    </div>
    <div class="card-body m-0">

        <div class="row mb-2">
      <div class="col-xl-10">

        <button type="button" class="btn bg-danger-custom"
                (click)="onExport()">
          <i class="feather icon-download me-2"></i>Export Excel
        </button>

        <button type="button" class="btn bg-danger-custom"
                (click)="quickFilterShowAction($event)">
          <i class="feather icon-filter me-2"></i>Quick Filters
        </button>
      </div>
    </div>

    <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">
      <div class="card">
        <div class="card-body">
          <div class="row">

            <div class="col-sm-4">
              <label class="col-form-label" for="customerMobile">Search By Contact Number</label>
              <input class="form-control"
                     [(ngModel)]="mobileNumber"
                     id="searchMID"
                     placeholder="Enter Contact Number"
                     (focus)="fun('searchMID')"
                     (focusout)="funover('searchMID')">
            </div>

            <div class="col-md-4">
              <label class="col-form-label" for="filStatus">Status</label>
              <ng-select #filStatus
                         [(ngModel)]="transactionStatus"
                         placeholder="Select KYC Status"
                         required
                         [inputAttrs]="{maxlength: '40'}"
                         id="filStatus"
                         (focus)="fun('filStatus')"
                         (focusout)="funover('filStatus')">
                <ng-option value="SELF_BANK_TRANSFER_INITIATED">Self Transafer Initiated</ng-option>
                <ng-option value="TRANSFER_INITIATED">Transfer Initiated</ng-option>
                <ng-option value="CANCELLED">Cancelled</ng-option>
                <ng-option value="TRANSFER_COMPLETED">Transfer Complete</ng-option>
              </ng-select>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-4 d-flex align-items-end">
              <button (click)="onSearchBtnClick($event)"
                      class="btn bg-danger-custom me-2"
                      type="button"
                      style="width: 100%;">
                <i class="feather icon-search me-2"></i>Search
              </button>

              <button (click)="resetFilter()"
                      class="btn btn-secondary"
                      type="button"
                      style="width: 100%;">
                <i class="feather icon-refresh-cw me-2"></i>Reset
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>



        <div class="row mb-0" style="min-height: 470px">
            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                <ag-grid-angular [enableCellTextSelection]=true 
                    (gridReady)="onGridReady()"[columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
                    [enableCellTextSelection]=true [paginationPageSize]="pageSize" [pagination]="true"
                    [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'" [suppressPaginationPanel]="true"
                    style="width: 100%; height: auto;">
                </ag-grid-angular>
            </div>
        </div>
        <div class="row mt-0">
            <div class="col-4 col-xs-4 d-flex">
                <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
                    class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
                    <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
                </select>
                <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
            </div>

            <div class="col-8 col-xs-8">
                <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
                    [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
                    [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
                </ngb-pagination>
            </div>

        </div>
    </div>

</div>
  <app-modal #modalTopupAction [modalConfig]="modalConfigBlocked">
  <app-merchant-withdrawal-action
    (closeModal)="closeModalTopup($event)"
    [merchantStatusConfig]="tableInfo"
    [onMerchantMId]="TopupActionSelectEvent">
  </app-merchant-withdrawal-action>
</app-modal>